import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABDScreenContainer.module.scss';

export interface ScreenContainerProps
  extends Readonly<{
    shouldUseAppHorizontalMargin?: boolean;
    children?: React.ReactNode;
  }> {}

export const ScreenContainer = React.memo<ScreenContainerProps>((props) => {
  const { shouldUseAppHorizontalMargin = true, children } = props;

  const ContainerClassNames = React.useMemo<string>(() => {
    const containerClassNames: string[] = [classNames.container];

    if (shouldUseAppHorizontalMargin) {
      containerClassNames.push(classNames.appHorizontalMargin);
    }

    return StyleUtil.mergeClassNames(containerClassNames);
  }, [shouldUseAppHorizontalMargin]);

  return <div className={ContainerClassNames}>{children}</div>;
});
